module.exports = __webpack_public_path__ + "img/appAsset-brand--Twilio.73b45637.svg";